import type { FaireProductEntity } from "../../entity_types/product";

export const p_2mv49adtxg: FaireProductEntity = {
  token: "p_2mv49adtxg",
  type: "product",
  name: "Ooey Gooey Cinnamon Rolls | Dessert Scented Soy Wax Candle",
  brandToken: "b_38ectsymfw",
  brandName: "The Prairie Bakery Candle Kitchen LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/86771b08bcf3161e0775f32f4219be86e29a64e0866bd8d1f53361a14cca5888.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/32da30acfa151e24795b571e991d83aea7e9899ae0dde5fed284a800340c8389.jpeg",
  ],
  priceDollars: 8,
  description:
    "The scent of warm, gooey cinnamon rolls - with butter and vanilla icing!\n\nYour new candle features:\n•\t100% Renewable, Non-Toxic, Vegan Clean-Burning Soy Wax\n•\tLow-Smoke Hemp Wick\n•\tRustic 8 oz Canning Jar with Pewter-Style Lid\n•\tKraft Paper Label and additional Warning Label on bottom\n\nOur candles are hand-poured in small batches right in our kitchen. All of our supplies are sourced locally. Makes a great gift!\n\nPlease Note:\n•\tNatural Soy Wax has a tendency to frost, crystalize, and shadow (separate from the glass). This is totally normal and will not affect the performance of your candle!\n•\tThe color may vary slightly from the photo and there may be a discrepancy in how I describe the scent and how you perceive it.\n•\tShipping during warm weather is always a risk for items that can melt so please be sure to bring your order inside as soon as you’re able.",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:00.216Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
